export const DEFAULT_DRAG_DISTANCE_PX = 12;

export interface DragDistancePoint {
	x: number;
	y: number;
}

export function getDragDistance(
	start: DragDistancePoint,
	current: DragDistancePoint,
) {
	return Math.hypot(current.x - start.x, current.y - start.y);
}

export function hasExceededDragDistance(
	start: DragDistancePoint,
	current: DragDistancePoint,
	distance = DEFAULT_DRAG_DISTANCE_PX,
) {
	return getDragDistance(start, current) > distance;
}
